import React, {PropsWithChildren} from 'react';
import MuiTextField, {StandardTextFieldProps} from '@material-ui/core/TextField';
import {makeStyles, createStyles} from '@material-ui/core/styles';
import {Typography} from '../../typography';
import {UeTheme} from 'epic-ue-theme/src/ueTheme.types';
export interface TextFieldProps extends StandardTextFieldProps {
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
}

const useStyles = makeStyles((theme: UeTheme) =>
    createStyles({
        formControlRoot: {
            width: '100%'
        },
        root: {
            height: '48px',
            padding: '8px',
            borderRadius: 'unset',
            width: '100%',
            '& + p': {
                alignSelf: 'flex-start'
            }
        },
        input: {
            height: '48px !important',
            padding: '8px !important',
            background: 'transparent'
        },
        error: {
            border: `1px solid ${theme.palette.accent.bright.fire}`,
            '& input': {
                height: '46px'
            },
            '& + p': {
                color: theme.palette.accent.bright.fire,
                margin: 0,
                fontSize: '0.75rem'
            }
        },
        focused: {
            outline: `1px solid ${theme.ue.colors.outline}`,
            outlineOffset: `-1px`
        }
    })
);

export const TextField = ({
    endAdornment,
    startAdornment,
    children,
    ...props
}: PropsWithChildren<TextFieldProps>): JSX.Element => {
    const classes: any = useStyles();
    return (
        <MuiTextField
            className="ue-text-field"
            {...props}
            variant="filled"
            classes={{
                root: classes.formControlRoot
            }}
            InputProps={{
                classes: {
                    root: classes.root,
                    input: classes.input,
                    error: classes.error,
                    focused: classes.focused
                },
                disableUnderline: true,
                endAdornment,
                startAdornment
            }}>
            <Typography variant="p">{children}</Typography>
        </MuiTextField>
    );
};
